<template>
  <div class="col-news">
    <div
      class="ma-0 py-0 pr-2"
      v-for="(col, idx) in groupedColumns"
      :key="idx"
    >
    <div v-for="(group, gIdx) in col">
      <div class="card-col">
        <div class="card-row" :style="{ minHeight: formatSizing.height }" :class="latestNews(group.items[0].date).active">
          <div
            :style="{width: formatSizing.width}"
            style="border-right:thin solid #3d3d3d"
            class="d-flex flex-column align-start justify-center px-2 pr-8"
            
          >
            <div
                :key="gIdx"
                class="news-date"
                :style="{ '--news-font-size': (parseFloat(fontSizeFormat) - 3) + 'px' }"
              >
                {{ groupByTimeRange(group) }}
              </div>
            <div
              class="news-source"
              :style="{
                '--news-font-size': parseFloat(fontSizeFormat) - 2 + 'px',
              }"
            >
              {{ group.author.length > 14 ?
              `${group.author.slice(0,10)}...` :
              `${group.author}`
                }}
            </div>
          </div>
          <div class="titles-col">
            
            <div
              v-for="(article, index) in group.items"
              :key="article.url"
              @click="openNews(article.url)"
              class="pr-1"
              style="cursor: pointer"
            >
              <v-tooltip bottom content-class="custom-tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="news-content"
                    v-on="on"
                    v-bind="attrs"
                    :style="{ '--news-font-size': fontSizeFormat }"
                  >
                    {{ formatTitle(article.title) }}
                  </span>
                </template>
                {{ article.title }} - <b>{{ article.author }}</b>
              </v-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>

    </div>
  </div>
</template>

<script>
import * as utils from "@/utils/utils.js";
import { useSettingsStore } from "@/store/index.js";

export default {
  name: "NewsColumn",
  props: {
    col: { required: true },
    latest: { required: false },
  },
  data() {
    return {
      topics: [],
      fontsSetting: useSettingsStore(),
    };
  },
  computed: {
    isOnModal(){
      return this.fontsSetting.isModalOn
    },
    screenSizeFormat() {
      return this.fontsSetting.formatScreenSize()
    },
    fontSizeFormat() {
        return  this.fontsSetting.formatFontSize(this.screenSizeFormat)
    },
    limitedSlides() {
      return this.slides.slice(0, 15);
    },
    formatSizing() {
      if(this.fontsSetting.fontsize === 'LG')
      {
        return {
          'height': '3.5vh',
          'width':  '100px' ,
        }
      }
      else  if(this.fontsSetting.fontsize === 'MD')
      {
        return {
          'height': '3.5vh',
          'width':  '100px' ,
        }
      }
      else
      {
        return {
          'height': '2.5vh',
          'width': '100px' ,
        }
      }
    },
    groupedColumns() {
      const items = this.groupByAuthor
      const half = Math.ceil(items.length / 2)
      const list_news = !this.isOnModal ? [ items.slice(0, half).slice(0, 5), items.slice(0, half).slice(5) ] : [items.slice(0, half), items.slice(half)]
      return list_news
  },
    groupByAuthor() {
      const flat = [];
      Object.entries(this.col).forEach(([date, authors]) => {
        Object.entries(authors).forEach(([author, articles]) => {
          articles.forEach((article) => {
            flat.push({
              ...article,
              author,
              date,
              timestamp: utils.parseTimestamp(article.time_published),
            });
          });
        });
      });

      flat.sort((a, b) => b.timestamp - a.timestamp);

      const groups = [];
      let currentGroup = null;

      flat.forEach((item) => {
        if (!currentGroup || currentGroup.author !== item.author) {
          currentGroup = {
            author: item.author,
            items: [],
          };
          groups.push(currentGroup);
        }

        currentGroup.items.push(item);
      });
      return groups;
    },
  },
  methods: {
    latestNews(date) {
      if (
        date ===
        this.formatFromCustomString(this.latest.time_published, "smallScreen")
      ) {
        return {
          border: "thin solid #0073ff",
          active: "latest-news",
        };
      }
      return {
        border: "thin solid #3d3d3d",
        active: "fade",
      };
    },
    formatDateOnly(date) {
      // "Mar 18, 26, 13:16" → "18/03"
      const parts = date.split(',')[0].split(' ')
      const day = parts[1]
      const month = new Date(`${parts[0]} 1`).getMonth() + 1

      return `${day}/${String(month).padStart(2, '0')}`
    },
    getTimeOnly(date){
      return date.split(', ').pop()
    },
    groupByTimeRange(group){
      if(!group.items.length) return ''

      const first = this.getTimeOnly(group.items[0].date)
      const last = this.getTimeOnly(group.items[group.items.length -1].date)

      const date = this.formatDateOnly(group.items[0].date)

      if (first === last) {
          return `${date} (${first})`
        }

        return `${date} (${first} - ${last})`
    },
    formatTitle(item) {
      const isSmall = ["mobile", "tablet", "smallScreen"].includes(
        this.screenSizeFormat,
      );
      return this.fontsSetting.formatFileName(item, isSmall);
    },
    openNews(url) {
      window.open(url, "_blank");
    },
    formatFromCustomString(dateString, formatType) {
      return utils.formatFromCustomString(dateString, formatType);
    },
  },
};
</script>
<style scoped>
.news-date {
  font-size: var(--news-font-size) !important;
  text-wrap: nowrap;
  text-align: center;
  margin: 0rem;
  line-height: 0.7rem;
}
.latest-news {
  background: rgb(37, 37, 37);
  padding: 0;
  margin: 0;
}
.news-source {
  font-size: var(--news-font-size) !important;
  text-wrap: nowrap;
  font-style: italic;
  line-height: 0.7rem;
  margin: 0;
}
.news-content {
  font-size: var(--news-font-size) !important;
  font-weight: bold;
  display: flex;
  flex-direction: column;
  pointer-events: auto;
  text-align: start;
  cursor: pointer;
  line-height: 0.8rem !important;
  margin-left: 0.6rem;
  padding: .5rem 0;
  justify-content: center;
  height: 100%;
}
.three-dot-icon {
  opacity: 0.5;
  position: absolute;
  left: 50%;
  bottom: -20px;
}
.col-news {
  display: flex;
  flex-direction: column;
  gap:0 .1rem;
  margin: 0;
  padding: 0;
  width: 100%;
  align-items: flex-start;
  justify-content: flex-start;
  min-height: 0;
  flex: 1;
}

.col-news > * {
  min-width: 0;
  width: 100%;
}
.card-row {
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: stretch;
  padding: 0.05rem 0;

  min-width: 0;
  border-bottom: 1px solid #3d3d3d;
}
.titles-col {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
}
.card-col {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0.3rem 0;
}
.v-tooltip__content {
  max-width: 300px !important;
  line-height: 1rem;
}

.fade:hover {
  background-color: rgb(45, 45, 45);
  border-radius: 1%;
}
.custom-tooltip{
  background:rgb(81, 81, 81)
}
</style>
